
import { Users, UserRound } from "lucide-react";

const Topics = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
      <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-3">
          <Users className="h-6 w-6 text-kaija-slate mr-2" />
          <h3 className="text-xl font-medium">Vastupidav ja ühtne meeskond</h3>
        </div>
        <p className="text-gray-700">
          Kohandatud koolitusprogrammid töötajate vastupidavuse, tööheaolu ja meeskonnatöö tugevdamiseks.
        </p>
      </div>
      
      <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-3">
          <UserRound className="h-6 w-6 text-kaija-slate mr-2" />
          <h3 className="text-xl font-medium">Trauma mõju mõistmine</h3>
        </div>
        <p className="text-gray-700">
          Uuritakse, kuidas trauma ja stress võivad mõjutada töötajate käitumist ning pakutakse praktilisi lahendusi traumateadlikkuse suurendamiseks ja toetava töökeskkonna loomiseks.
        </p>
      </div>
    </div>
  );
};

export default Topics;
